import QrCodeForm from "./QrCodeForm";

export default QrCodeForm